import PlusSvg from "./plus-svg";
import { ShapeLine } from "./shape-line";
import { CloseThreeSvg } from "./close-svg";
import { EmailThree, EmailTwo } from "./email";
import Location, { LocationFour } from "./location";
import { TelSvgTwo } from "./tel-svg";
import HandCheck from "./hand-check";
import ShareSvg from "./share-svg";
import LinkSvg from "./link-svg";
import QuoteSvg from "./quote-svg";
import HomeSvg from "./home-svg";
import CircleSvg from "./circle-svg";
import { PlaySvg } from "./play-svg";
import { ShapeTwo, Shape } from "./shape";
import ClockSvg from "./clock-svg";
import { VideoPlayerSvg } from "./play-svg";
import dynamic from "next/dynamic";

const FeesIcons = {
  OneTimeFeesSvg: dynamic(() =>
    import("../svg/fees-svg").then((m) => m.OneTimeFeesSvg)
  ),
  SemesterBasedFeesIconSvg: dynamic(() =>
    import("../svg/fees-svg").then((m) => m.SemesterBasedFeesIconSvg)
  ),
  CreditHourFeesIconSvg: dynamic(() =>
    import("../svg/fees-svg").then((m) => m.CreditHourFeesIconSvg)
  ),
};
const ProgramsIcons = {
  FundamentalsIcon: dynamic(() =>
    import("../svg/programs").then((m) => m.FundamentalsIcon)
  ),
  RegulationsIcon: dynamic(() =>
    import("../svg/programs").then((m) => m.RegulationsIcon)
  ),
  BylawsIcon: dynamic(() =>
    import("../svg/programs").then((m) => m.BylawsIcon)
  ),
};
const SocialIcons = {
  FbSvg: dynamic(() => import("../svg/social-svg").then((m) => m.FbSvg)),
  InstagramSvg: dynamic(() =>
    import("../svg/social-svg").then((m) => m.InstagramSvg)
  ),
  LinkedinSvg: dynamic(() =>
    import("../svg/social-svg").then((m) => m.LinkedinSvg)
  ),
};
const ArrowIcons = {
  RightArrow: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrow)
  ),
  LeftArrow: dynamic(() => import("../svg/arrow-svg").then((m) => m.LeftArrow)),
  NextArrow: dynamic(() => import("../svg/arrow-svg").then((m) => m.NextArrow)),
  PrevArrow: dynamic(() => import("../svg/arrow-svg").then((m) => m.PrevArrow)),
  LeftSmArrowThree: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.LeftSmArrowThree)
  ),
  RightSmArrowThree: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightSmArrowThree)
  ),
  DownArrow: dynamic(() => import("../svg/arrow-svg").then((m) => m.DownArrow)),
  UpArrow: dynamic(() => import("../svg/arrow-svg").then((m) => m.UpArrow)),
  RightArrowTwo: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrowTwo)
  ),
  LeftArrowTwo: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.LeftArrowTwo)
  ),
  NextArrowTwo: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.NextArrowTwo)
  ),
  PrevArrowTwo: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.PrevArrowTwo)
  ),
  PrevArrowThree: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.PrevArrowThree)
  ),
  RightArrowFour: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrowFour)
  ),
  LeftArrowFour: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.LeftArrowFour)
  ),
  DownArrowThree: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.DownArrowThree)
  ),
  RightArrowSeven: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrowSeven)
  ),
  RightArrowFive: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrowFive)
  ),
  RightArrowSix: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.RightArrowSix)
  ),
  LeftArrowSeven: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.LeftArrowSeven)
  ),
  LeftArrowSix: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.LeftArrowSix)
  ),
  PreviousArrow: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.PreviousArrow)
  ),
  NextArrowThree: dynamic(() =>
    import("../svg/arrow-svg").then((m) => m.NextArrowThree)
  ),
};

export {
  CloseThreeSvg,
  EmailThree,
  EmailTwo,
  Location,
  LocationFour,
  TelSvgTwo,
  HandCheck,
  ShareSvg,
  LinkSvg,
  QuoteSvg,
  HomeSvg,
  CircleSvg,
  PlaySvg,
  ShapeTwo,
  Shape,
  FeesIcons,
  ProgramsIcons,
  SocialIcons,
  ArrowIcons,
  ShapeLine,
  PlusSvg,
  ClockSvg,
  VideoPlayerSvg,
};
